import { CodeBlock } from '@mysaiva/core'
import type { DocBlock } from '../../docs'
import { DocInline } from './DocInline'
import { DocTable } from './DocTable'
import styles from './Docs.module.scss'

/** Renders a list of documentation blocks. */
export function DocBlocks({ blocks }: { blocks: DocBlock[] }) {
  return (
    <>
      {blocks.map((block, index) => {
        switch (block.type) {
          case 'heading':
            return (
              <h3 key={index} id={block.id} className={styles.sectionTitle}>
                {block.text}
              </h3>
            )
          case 'paragraph':
            return (
              <p key={index} className={styles.paragraph}>
                <DocInline text={block.text} />
              </p>
            )
          case 'bullets':
            return (
              <div key={index} className={styles.section}>
                {block.lead && (
                  <p className={styles.lead}>
                    <DocInline text={block.lead} />
                  </p>
                )}
                {block.ordered ? (
                  <ol className={styles.bullets}>
                    {block.items.map((item, itemIndex) => (
                      <li key={itemIndex}>
                        <DocInline text={item} />
                      </li>
                    ))}
                  </ol>
                ) : (
                  <ul className={styles.bullets}>
                    {block.items.map((item, itemIndex) => (
                      <li key={itemIndex}>
                        <DocInline text={item} />
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )
          case 'note':
            return (
              <p key={index} className={styles.note}>
                <DocInline text={block.text} />
              </p>
            )
          case 'table':
            return <DocTable key={index} table={block.table} id={block.id} />
          case 'code':
            return (
              <CodeBlock
                key={index}
                title={block.title}
                code={block.code}
                language={block.language ?? 'text'}
                lineNumbers={block.lineNumbers}
                wrap
                data-testid="doc-code"
              />
            )
          default:
            return null
        }
      })}
    </>
  )
}
